import { gql } from "@apollo/client";

export const IS_API_USER = gql`
    query isApiUser {
        isApiUser {
            hasApiKey
        }
    }
`;
